import axios from 'utils/bsac-api.js';
import defaultValues from 'constant/eleraning-application/default-values';
import testValues from 'constant/eleraning-application/test-values';

const state = () => Object.assign({}, defaultValues);

const getters = {
  applicant: (state) => state.applicant,
  course: (state) => state.course,
  diveCenter: (state) => state.diveCenter,
  emergency: (state) => state.emergency,
  rental: (state) => state.rental,
  requestBodyForRegister: (state) => state.requestBodyForRegister,
  payBy: (state) => state.payBy,
  registerResponse: (state) => state.registerResponse,
  inputSummary: (getters) => {
    if (
      getters.applicant === null ||
      getters.course === null ||
      getters.diveCenter === null ||
      getters.emergency === null ||
      getters.rank === null
    )
      return {
        title: 'こちらをクリックすると入力内容をご確認いただけます。',
        categories: [],
      };

    const NOT_ENTERED = '(未入力)';

    return {
      title: 'こちらをクリックすると入力内容をご確認いただけます。',
      categories: [
        {
          name: '受講コース　ダイブセンター/インストラクター',
          items: [
            {
              key: '受講コース',
              value: getters.course.name ? getters.course.name : NOT_ENTERED,
            },
            {
              key: '受講料金（税込）',
              value: getters.course.priceWithTax
                ? getters.course.priceWithTax.toLocaleString() + ' 円'
                : NOT_ENTERED,
            },
            {
              key: 'ダイブセンター/インストラクター',
              value:
                (getters.diveCenter.others ? getters.diveCenter.others : getters.diveCenter.name) + 
                ` (${(getters.diveCenter.othersEmail ? getters.diveCenter.othersEmail : getters.diveCenter.email)})`
            },
          ],
        },
        {
          name: 'お申込者情報',
          items: [
            {
              key: '氏名（漢字）',
              value: getters.applicant.nameJa ? getters.applicant.nameJa : NOT_ENTERED,
            },
            {
              key: '氏名（カナ）',
              value: getters.applicant.nameKana ? getters.applicant.nameKana : NOT_ENTERED,
            },
            {
              key: '氏名（英字）',
              value: getters.applicant.nameEn ? getters.applicant.nameEn : NOT_ENTERED,
            },
            {
              key: '生年月日',
              value:
                getters.applicant.birthAtYear +
                '年' +
                getters.applicant.birthAtMonth +
                '月' +
                getters.applicant.birthAtDay +
                '日',
            },
            {
              key: '性別',
              value: getters.applicant.gender === '1' ? '男性' : '女性',
            },
            {
              key: '血液型',
              value: getters.applicant.bloodType ? getters.applicant.bloodType : NOT_ENTERED,
            },
            {
              key: '郵便番号',
              value: getters.applicant.postCode ? getters.applicant.postCode : NOT_ENTERED,
            },
            {
              key: '都道府県',
              value: getters.applicant.prefecture ? getters.applicant.prefecture : NOT_ENTERED,
            },
            {
              key: '市区町村、丁目・番地',
              value: getters.applicant.address1st ? getters.applicant.address1st : NOT_ENTERED,
            },
            {
              key: '市区町村、丁目・番地（カナ）',
              value: getters.applicant.address1stKana
                ? getters.applicant.address1stKana
                : NOT_ENTERED,
            },
            {
              key: '建物名など',
              value: getters.applicant.address2nd ? getters.applicant.address2nd : NOT_ENTERED,
            },
            {
              key: '建物名など（カナ）',
              value: getters.applicant.address2ndKana
                ? getters.applicant.address2ndKana
                : NOT_ENTERED,
            },
            {
              key: '電話番号',
              value: getters.applicant.tel ? getters.applicant.tel : NOT_ENTERED,
            },
            {
              key: '携帯番号',
              value: getters.applicant.mobile ? getters.applicant.mobile : NOT_ENTERED,
            },
            {
              key: 'e-mail（PC・携帯）',
              value: getters.applicant.email ? getters.applicant.email : NOT_ENTERED,
            },
            {
              key: '来店予定日',
              value:
                getters.applicant.visitAtYear +
                '年' +
                getters.applicant.visitAtMonth +
                '月' +
                getters.applicant.visitAtDay +
                '日',
            },
          ],
        },
        {
          name: '緊急連絡先情報',
          items: [
            {
              key: '氏名',
              value: getters.emergency.name ? getters.emergency.name : NOT_ENTERED,
            },
            {
              key: '氏名（カナ）',
              value: getters.emergency.nameKana ? getters.emergency.nameKana : NOT_ENTERED,
            },
            {
              key: '申込者との続柄',
              value: getters.emergency.familyRelationship
                ? getters.emergency.familyRelationship
                : NOT_ENTERED,
            },
            {
              key: '郵便番号',
              value: getters.emergency.postCode ? getters.emergency.postCode : NOT_ENTERED,
            },
            {
              key: '都道府県',
              value: getters.emergency.prefecture ? getters.emergency.prefecture : NOT_ENTERED,
            },
            {
              key: '市区町村、丁目・番地',
              value: getters.emergency.address1st ? getters.emergency.address1st : NOT_ENTERED,
            },
            {
              key: '市区町村、丁目・番地（カナ）',
              value: getters.emergency.address1stKana
                ? getters.emergency.address1stKana
                : NOT_ENTERED,
            },
            {
              key: '建物名など',
              value: getters.emergency.address2nd ? getters.emergency.address2nd : NOT_ENTERED,
            },
            {
              key: '建物名など（カナ）',
              value: getters.emergency.address2ndKana
                ? getters.emergency.address2ndKana
                : NOT_ENTERED,
            },
            {
              key: '電話番号',
              value: getters.emergency.tel ? getters.emergency.tel : NOT_ENTERED,
            },
            {
              key: '携帯番号',
              value: getters.emergency.mobile ? getters.emergency.mobile : NOT_ENTERED,
            },
            {
              key: 'e-mail（PC・携帯）',
              value: getters.emergency.email ? getters.emergency.email : NOT_ENTERED,
            },
          ],
        },
        {
          name: '器材をレンタルする際に必要な情報',
          items: [
            {
              key: '身長',
              value: getters.rental.height ? getters.rental.height + ' (cm)' : NOT_ENTERED,
            },
            {
              key: '体重',
              value: getters.rental.weight ? getters.rental.weight + ' (kg)' : NOT_ENTERED,
            },
            {
              key: '靴のサイズ',
              value: getters.rental.shoeSize ? getters.rental.shoeSize + ' (cm)' : NOT_ENTERED,
            },
            {
              key: '視力（右）',
              value: getters.rental.opticRight ? getters.rental.opticRight : NOT_ENTERED,
            },
            {
              key: '視力（左）',
              value: getters.rental.opticLeft ? getters.rental.opticLeft : NOT_ENTERED,
            },
          ],
        },
      ],
    };
  },
};

const mutations = {
  /**
   * ストアを初期化する
   * @param {*} state
   */
  reset(state) {
    state.applicant = Object.assign({}, defaultValues.applicant);
    state.course = Object.assign({}, defaultValues.course);
    state.diveCenter = Object.assign({}, defaultValues.diveCenter);
    state.emergency = Object.assign({}, defaultValues.emergency);
    state.payBy = Object.assign({}, defaultValues.payBy);
    state.registerResponse = Object.assign({}, defaultValues.registerResponse);
    state.rental = Object.assign({}, defaultValues.rental);
  },
  /**
   * テスト用データをセットする
   * @param {*} state
   */
  resetForTest(state) {
    state.applicant = Object.assign({}, testValues.applicant);
    state.course = Object.assign({}, testValues.course);
    state.diveCenter = Object.assign({}, testValues.diveCenter);
    state.emergency = Object.assign({}, testValues.emergency);
    state.payBy = Object.assign({}, testValues.payBy);
    state.registerResponse = Object.assign({}, testValues.registerResponse);
    state.rental = Object.assign({}, testValues.rental);

    state.applicant.nameJa += '_' + new Date().toLocaleTimeString();
  },
  /**
   * 申込内容をセットする
   * @param {*} state
   * @param {*} applicant
   */
  setApplication(state, inputForm) {
    state.applicant = inputForm.applicant;
    state.diveCenter = inputForm.diveCenter;
    state.emergency = inputForm.emergency;
    state.rental = inputForm.rental;
  },
  /**
   * コースをセットする
   * @param {*} state
   * @param {*} course
   */
  setCourse(state, course) {
    state.course = course;
  },
  /**
   * 支払方法をセットする
   * @param {*} state
   * @param {*} payBy
   */
  setPayBy(state, payBy) {
    state.payBy = payBy;
  },
  /**
   * 登録時のレスポンスをセットする
   * @param {*} state
   * @param {*} response
   */
  setRegisterResponse(state, response) {
    state.registerResponse.status = response.status;
    state.registerResponse.message = response.data.message;
    state.registerResponse.payBy = response.data.pay_by;
    state.registerResponse.redirectUrl = response.data.redirect_url;
  },
  /**
   * 登録用リクエストボディをセットする
   * @param {*} state
   * @param {*} payBy
   */
  setRequestBodyForRegister(state, requestBody) {
    state.requestBodyForRegister = requestBody;
  },
};

const actions = {
  /**
   * APIを呼び出し申込内容を登録する
   * @param {*} param0
   * @param {*} state
   * @returns
   */
  register({ getters, dispatch, commit }) {
    dispatch('generateRequestBodyForRegister');
    return axios
      .post(
        process.env.FRONT_URL + '/elearning/elearning_applications',
        JSON.stringify(getters['requestBodyForRegister'])
      )
      .then((response) => {
        // console.debug('success response:' + JSON.stringify(response));
        commit('setRegisterResponse', response);
        return {
          success: true,
          status: response.status,
          message: response.data.message,
        };
      })
      .catch((error) => {
        // console.error('error error:' + JSON.stringify(error));
        return {
          success: false,
          status: error.status,
          message: error.message,
        };
      });
  },
  /**
   * 登録用リクエストボディを生成する
   * @param {*} param0
   * @returns
   */
  generateRequestBodyForRegister({ state, commit, getters, rootGetters }) {
    if (getters.applicant === null) return null;
    if (getters.course === null) return null;
    if (getters.diveCenter === null) return null;
    if (getters.emergency === null) return null;
    if (getters.rank === null) return null;

    const requestBody = {
      elearning_application: {
        dive_center_id: getters.diveCenter.id ? getters.diveCenter.id : -1,
        dive_center_name: getters.diveCenter.others
          ? getters.diveCenter.others
          : getters.diveCenter.name,
        dive_center_email: getters.diveCenter.othersEmail
          ? getters.diveCenter.othersEmail
          : getters.diveCenter.email,
        rank_id: getters.course.rankId,
        course_name: getters.course.name,
        course_price: getters.course.price,
        pay_by: getters.payBy,
        visit_at:
          getters.applicant.visitAtYear +
          '-' +
          getters.applicant.visitAtMonth +
          '-' +
          getters.applicant.visitAtDay,
        name_ja: getters.applicant.nameJa,
        name_kana: getters.applicant.nameKana,
        name_en: getters.applicant.nameEn,
        birth_at:
          getters.applicant.birthAtYear +
          '-' +
          getters.applicant.birthAtMonth +
          '-' +
          getters.applicant.birthAtDay,
        gender: getters.applicant.gender,
        blood_type: getters.applicant.bloodType,
        postcode: getters.applicant.postCode,
        prefecture: getters.applicant.prefecture,
        address_1st: getters.applicant.address1st,
        address_1st_kana: getters.applicant.address1stKana,
        address_2nd: getters.applicant.address2nd,
        address_2nd_kana: getters.applicant.address2ndKana,
        phone_no: getters.applicant.tel,
        mobile_no: getters.applicant.mobile,
        email: getters.applicant.email,
        emergency_name_ja: getters.emergency.name,
        emergency_name_kana: getters.emergency.nameKana,
        emergency_family_relationship: getters.emergency.familyRelationship,
        emergency_postcode: getters.emergency.postCode,
        emergency_prefecture: getters.emergency.prefecture,
        emergency_address_1st: getters.emergency.address1st,
        emergency_address_1st_kana: getters.emergency.address1stKana,
        emergency_address_2nd: getters.emergency.address2nd,
        emergency_address_2nd_kana: getters.emergency.address2ndKana,
        emergency_phone_no: getters.emergency.tel,
        emergency_mobile_no: getters.emergency.mobile,
        emergency_email: getters.emergency.email,
        height: getters.rental.height,
        weight: getters.rental.weight,
        shoe_size: getters.rental.shoeSize,
        optic_right: getters.rental.opticRight,
        optic_left: getters.rental.opticLeft,
        medical_check_answers: JSON.stringify(rootGetters['medicalCheck/answers']),
      },
    };

    commit('setRequestBodyForRegister', requestBody);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
